const API_URL = 'https://renewalapi.claritybenefitsolutions.com/api';
const WEB_URL = 'https://renewal.claritybenefitsolutions.com'

export default {
  API_URL,
  WEB_URL
};